import { render, staticRenderFns } from "./CardRowInfo.vue?vue&type=template&id=4dbc614d"
import script from "./CardRowInfo.vue?vue&type=script&lang=js"
export * from "./CardRowInfo.vue?vue&type=script&lang=js"
import style0 from "./CardRowInfo.vue?vue&type=style&index=0&id=4dbc614d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports